module.exports = __webpack_public_path__ + "img/ug534.220294b8.png";